import { SharedConstants } from "../../../../shared/constants/shared.constants";
export class ModuleRolesConstants {
    static REMOVE_TITLE = `${SharedConstants.REMOVE_TITLE} module role`;
    static REMOVE_CONTENT = `${SharedConstants.REMOVE_MESSAGE} module role(s)?`;
    static EDIT_TITLE = "Edit module role";
    static ADD_TITLE = "Add module role";
    static ROLE_FORM_CONTROL = "role";
    static ROLE_TEXT = "Module role";
    static MODULE_ID_FILTER_STRING = "moduleId eq";
    static SYSTEM_FILTER_STRING = "userDefined eq true";
    static BULK_UPDATE_BUTTON_PLACEHOLDER = "Bulk User Update";
    static DUPLICATE_ITEMS_MESSAGE = "A module role with the provided name already exists. Please define a new module role";
}
export const validationMessage = {
    role: {
        required: `Role name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
};
